export const ATTACHMENT_MODULE_PREFIX = 'ATTACHMENT';
export const DEFAULT_ATTACHMENT_ID = -1;
//# sourceMappingURL=attachmentConstants.js.map